import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import AOS from "aos";
import "aos/dist/aos.css";
// Sass
import "./bulma.sass";

// Youtube
import VueYoutube from "vue-youtube";
Vue.use(VueYoutube);
// Font Awesome integration
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faDharmachakra,
  faVideo,
  faHeadphones
} from "@fortawesome/free-solid-svg-icons";
import {
  faYoutube,
  faFacebook,
  faTwitter
} from "@fortawesome/free-brands-svg-icons";

library.add(
  faDharmachakra,
  faVideo,
  faHeadphones,
  faYoutube,
  faFacebook,
  faTwitter
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
  created() {
    AOS.init();
  }
}).$mount("#app");
